import React from 'react'
import { Button, useMediaQuery } from '@material-ui/core'
import { useStyles } from './styles'
import { CardContent, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import ModalContainer from '../../../Components/AtomicDesign/atoms/ModalContainer/ModalContainer'

const SelectedCard = () => {
  const isSmallScreen = useMediaQuery('(max-width:492px)')
  const isMidScreen = useMediaQuery('(max-width:1112px)')
  const isMobileScreen = useMediaQuery('(max-width:600px)')
  const isLargeScreen = useMediaQuery('(min-width:1200px)')
  
  const classes = useStyles({ 
    isSmallScreen, 
    isMidScreen, 
    isMobileScreen,
    isLargeScreen
  })
  
  const { selectedCard } = useSelector((state) => state.creditLimitRequest)

  const [isOpenModalDetail, setIsOpenModalDetail] = React.useState(false)

  return (
    <React.Fragment>
      <div className={classes.CreditCardInfo}>
        {selectedCard.cardImage ? (
          <img
            style={{ margin: '0 auto 8px auto' }}
            width={isSmallScreen ? 224 : 289}
            src={selectedCard.cardImage}
            alt='selected card'
          />
        ) : (
          <div
            style={{
              width: isSmallScreen ? 224 : 289,
              height: isSmallScreen ? 224 : 132,
              margin: '0 auto',
              color: 'gray',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <p>...</p>
          </div>
        )}
        <div className={classes.CreditCardInfoBody}>
          <Typography fontSize={14} fontWeight={500}>
            Selected Card
          </Typography>
          <Typography fontSize={16} fontWeight={700}>
            {selectedCard.title}
          </Typography>
          <hr style={{ margin: '12px 0 20px 0' }} />
          <span style={{ display: 'flex', gap: '1rem' }}>
            <Typography fontSize={14}>
              Benefits
            </Typography>
            <span style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {selectedCard.benefits.map((item, indx) => (
                <img key={indx} src={item.icon} alt={item.title} />
              ))}
            </span>
          </span>
          <br />
          <Button
            fullWidth
            style={{
              background: '#005FAA',
              color: '#fff',
              borderRadius: '1.5rem'
            }}
            onClick={() => setIsOpenModalDetail(true)}
          >
            Learn More.
          </Button>
        </div>
      </div>

      {selectedCard && (
        <ModalContainer
          open={isOpenModalDetail}
          width={isSmallScreen ? '95%' : '100%'}
          onClose={() => {
            setIsOpenModalDetail(false)
          }}
        >
          <div className={classes.modalContainer}>
            <CardContent className={classes.modalContent}>
              <div className={classes.modalInfoContainer}>
                <Typography className={classes.modalCardTitle}>
                  {selectedCard.title}
                </Typography>

                <ul className={classes.modalFeaturesList}>
                  {selectedCard.features.map((points, indx) => (
                    <li key={indx}>
                      <Typography className={classes.modalFeatureItem}>{points.title}</Typography>
                    </li>
                  ))}
                </ul>

                <hr style={{ marginTop: 8, marginBottom: 20 }} />

                {selectedCard?.benefits.map((benefit, indx) => (
                  <div key={indx} className={classes.modalBenefitItem}>
                    <img
                      src={benefit.icon}
                      width={25}
                      height={25}
                      alt=''
                      className={classes.modalBenefitIcon}
                    />
                    <Typography className={classes.modalBenefitText}>
                      <div dangerouslySetInnerHTML={{ __html: benefit.text }} />
                    </Typography>
                  </div>
                ))}
              </div>

              <div className={classes.modalCardImageContainer}>
                <img
                  className={classes.modalCardImage}
                  width={!isSmallScreen ? 350 : 170}
                  src={selectedCard.cardImage}
                  alt='current card selected'
                />
              </div>
            </CardContent>

            <div className={classes.modalButtonContainer}>
              <Button
                onClick={() => {
                  setIsOpenModalDetail(false)
                }}
                className={`${classes.BtnReject} ${classes.modalCloseButton}`}
              >
                Close
              </Button>{' '}
            </div>
          </div>
        </ModalContainer>
      )}
    </React.Fragment>
  )
}

export default SelectedCard
